<div id="frequencia-page" class="min-h-screen bg-gray-50 dark:bg-gray-900 pb-20">

  <!-- Sem contexto: mensagem e CTA ficam no app-context-card (layout global). Aqui não exibe funcionalidades. -->

  <!-- Alerta de Configuração de Frequência (Fixo no topo) - NÃO exibe quando semCalendario -->
  <!-- Guards: !carregandoDadosIniciais e !carregandoDadosTurma evitam falso positivo durante o carregamento -->
  <div id="alerta-mensagem" *ngIf="mensagem && !semContexto && !semCalendario && !carregandoDadosIniciais && !carregandoDadosTurma"
       #alertaMensagem
       class="mx-3 mb-4 rounded-xl shadow-lg overflow-hidden border-2 border-red-300 dark:border-red-700 bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50 dark:from-red-900/20 dark:via-orange-900/20 dark:to-yellow-900/20 backdrop-blur-sm animate-fade-in"
       role="alert"
       aria-live="assertive">
    <div class="flex items-start gap-3 p-4">
      <!-- Ícone de Alerta -->
      <div class="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-orange-600 dark:from-red-600 dark:to-orange-700 flex items-center justify-center shadow-md animate-pulse-slow">
        <lucide-icon name="alert-triangle" class="w-6 h-6 text-white"></lucide-icon>
      </div>
      
      <!-- Conteúdo do Alerta -->
      <div class="flex-1 min-w-0">
        <h3 class="text-base font-bold text-red-900 dark:text-red-100 mb-1 tracking-tight">
          Atenção!
        </h3>
        <p class="text-sm font-medium text-red-800 dark:text-red-200 leading-relaxed">
          {{ mensagem }}
        </p>
        <p class="text-xs text-red-700 dark:text-red-300 mt-2 italic">
          Entre em contato com a secretaria escolar para mais informações.
        </p>
      </div>
      
      <!-- Ícone de Info (não fecha mais) -->
      <div class="flex-shrink-0 w-8 h-8 rounded-lg bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300 flex items-center justify-center">
        <lucide-icon name="info" class="w-4 h-4"></lucide-icon>
      </div>
    </div>
  </div>

  <!-- Main content: só quando há contexto (turma); empty state global no context-card -->
  <div id="frequencia-main-content" class="p-4" *ngIf="!semContexto">

      <!-- Calendário não configurado (sem períodos) ou mês sem dias letivos retornados pela API -->
      <app-empty-state
        id="alerta-sem-calendario"
        *ngIf="semCalendario || deveExibirAvisoCalendarioSemDiasLetivosNoMes()"
        icone="alert-triangle"
        tema="yellow"
        titulo="Esta turma não possui calendário escolar definido"
        descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para preencher estas informações no Cadastro de Turmas">
      </app-empty-state>

      <app-empty-state
        id="alerta-sem-configuracao-frequencia"
        *ngIf="semConfiguracaoFrequencia"
        icone="settings"
        titulo="Esta turma não possui configuração de frequência"
        descricao="Procure o(a) secretário(a) do seu estabelecimento de ensino para configurar a forma de registro de frequência da turma.">
      </app-empty-state>

      <!-- Conteúdo Normal (apenas quando há calendário) -->
      <div id="frequencia-conteudo-normal" *ngIf="!semCalendario && !semConfiguracaoFrequencia">

      <!-- Título e Seleção de Período (oculto quando não há dias letivos) -->
      <div id="frequencia-titulo-periodo" *ngIf="!deveExibirAvisoCalendarioSemDiasLetivosNoMes()" class="mb-3 flex flex-row items-center gap-2">
        <div class="min-w-0 basis-[42%]">
          <app-page-title headingId="frequencia-titulo" title="Frequência"></app-page-title>
        </div>

        <!-- Seleção de Período (oculto quando não há dias letivos) -->
        <div id="periodo-seletor" class="min-w-0 basis-[58%]" *ngIf="!deveExibirAvisoCalendarioSemDiasLetivosNoMes()">
          <app-periodo-select
            [options]="periodoOptions"
            [selectedId]="periodoAtual?.id ?? null"
            [disabled]="semContexto"
            (optionSelected)="onPeriodoOptionSelected($event)">
          </app-periodo-select>
        </div>
      </div>

      <!-- Seleção do Dia da Aula (oculto quando não há dias letivos) -->
      <div id="calendario-navegacao" *ngIf="!deveExibirAvisoCalendarioSemDiasLetivosNoMes()" class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-2 relative mb-1">
        <div class="flex items-center justify-between">
          <button
            id="calendario-mes-anterior-btn"
            (click)="mesAnterior()" 
            [disabled]="semContexto"
            class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent">
            <lucide-icon name="chevron-left" class="w-5 h-5 text-gray-600 dark:text-gray-300"></lucide-icon>
          </button>
          
          <button
            id="calendario-dropdown-btn"
            (click)="toggleCalendarioDropdown()"
            [disabled]="semContexto"
            class="flex items-center space-x-1.5 px-2 py-1 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors flex-1 justify-center disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent"
          >
            <div class="text-center">
              <div id="calendario-nome-mes" class="text-base font-bold text-gray-900 dark:text-gray-100">{{ getNomeMes() }}</div>
              <div
                *ngIf="exibirCalendarioDataCompleta()"
                id="calendario-data-completa"
                class="text-sm text-gray-600 dark:text-gray-300 whitespace-nowrap"
              >
                {{ formatarDataCompleta() }} | {{ getDiaSemana() }}
              </div>
            </div>
            <lucide-icon name="chevron-down" class="w-4 h-4 text-gray-600 dark:text-gray-300" 
                         [class.rotate-180]="calendarioDropdownAberto"></lucide-icon>
          </button>
          
          <button
            id="calendario-dia-seguinte-btn"
            (click)="diaSeguinte()"
            [disabled]="semContexto"
            class="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent dark:disabled:hover:bg-transparent">
            <lucide-icon name="chevron-right" class="w-5 h-5 text-gray-600 dark:text-gray-300"></lucide-icon>
          </button>
        </div>

        <!-- Overlay para fechar calendário -->
        <div
          id="calendario-overlay"
          *ngIf="calendarioDropdownAberto"
          class="fixed inset-0 z-40"
          (click)="fecharCalendarioDropdownPorOverlay()"
        ></div>

        <!-- Dropdown do Calendário -->
        <div
          id="calendario-dropdown"
          *ngIf="calendarioDropdownAberto"
          class="absolute top-full left-0 right-0 mt-2 bg-white dark:bg-gray-800 rounded-lg shadow-xl border border-gray-200 dark:border-gray-700 z-50 overflow-hidden"
        >
          <!-- Navegação de Mês -->
          <div id="calendario-mes-navegacao" class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 relative">
            <!-- Overlay para fechar dropdown de mês -->
            <div
              id="mes-overlay"
              *ngIf="mesDropdownAberto"
              class="fixed inset-0 z-40"
              (click)="mesDropdownAberto = false"
            ></div>

            <div class="flex items-center justify-between relative z-50">
              <button
                id="calendario-nav-mes-anterior-btn"
                (click)="navegarMesAnteriorCalendario()"
                [disabled]="!podeNavegarMesAnterior()"
                class="p-2 rounded-lg transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
                [class.hover:bg-gray-100]="podeNavegarMesAnterior()"
                [class.dark:hover:bg-gray-700]="podeNavegarMesAnterior()"
              >
                <lucide-icon name="chevron-left" class="w-5 h-5 text-gray-700 dark:text-gray-200"></lucide-icon>
              </button>
              
              <button
                id="mes-dropdown-btn"
                (click)="toggleMesDropdown()"
                [disabled]="carregandoMeses"
                class="flex items-center space-x-2 px-3 py-1.5 hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <div class="text-center font-bold text-gray-900 dark:text-gray-100">
                  {{ getNomeMes() }}
                </div>
                <div *ngIf="carregandoMeses" class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 dark:border-blue-400"></div>
                <lucide-icon *ngIf="!carregandoMeses" name="chevron-down" class="w-4 h-4 text-gray-600 dark:text-gray-300" 
                             [class.rotate-180]="mesDropdownAberto"></lucide-icon>
              </button>
              
              <button
                id="calendario-nav-mes-seguinte-btn"
                (click)="navegarMesSeguinteCalendario()"
                [disabled]="!podeNavegarMesSeguinte()"
                class="p-2 rounded-lg transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
                [class.hover:bg-gray-100]="podeNavegarMesSeguinte()"
                [class.dark:hover:bg-gray-700]="podeNavegarMesSeguinte()"
              >
                <lucide-icon name="chevron-right" class="w-5 h-5 text-gray-700 dark:text-gray-200"></lucide-icon>
              </button>
            </div>

            <!-- Dropdown de Meses -->
            <div
              id="mes-dropdown-lista"
              *ngIf="mesDropdownAberto"
              class="absolute left-0 right-0 top-full mt-1 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 z-50 overflow-hidden"
            >
              <!-- Loading State -->
              <div *ngIf="carregandoMeses" class="px-4 py-8">
                <div class="flex flex-col items-center justify-center space-y-3">
                  <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 dark:border-blue-400"></div>
                  <p class="text-sm text-gray-500 dark:text-gray-400">Carregando meses...</p>
                </div>
              </div>

              <!-- Grade de Meses (formato calendário) -->
              <div *ngIf="!carregandoMeses" class="p-4">
                <div id="mes-grid" class="grid grid-cols-3 gap-2">
                  <button
                    *ngFor="let mes of mesesDisponiveis; trackBy: trackByMesNumero"
                    [attr.id]="'mes-item-' + mes.numero"
                    (click)="selecionarMes(mes.numero)"
                    class="px-3 py-4 rounded-lg text-center transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
                    [class.bg-blue-500]="mes.numero === mesAtual && mes.temDiasLetivos"
                    [class.dark:bg-blue-600]="mes.numero === mesAtual && mes.temDiasLetivos"
                    [class.text-white]="mes.numero === mesAtual && mes.temDiasLetivos"
                    [class.font-bold]="mes.numero === mesAtual"
                    [class.bg-gray-50]="mes.numero !== mesAtual && mes.temDiasLetivos"
                    [class.dark:bg-gray-700]="mes.numero !== mesAtual && mes.temDiasLetivos"
                    [class.hover:bg-blue-100]="mes.numero !== mesAtual && mes.temDiasLetivos"
                    [class.dark:hover:bg-gray-600]="mes.numero !== mesAtual && mes.temDiasLetivos"
                    [class.hover:scale-105]="mes.temDiasLetivos"
                    [class.hover:shadow-md]="mes.temDiasLetivos"
                    [class.active:scale-95]="mes.temDiasLetivos"
                    [class.text-gray-900]="mes.numero !== mesAtual && mes.temDiasLetivos"
                    [class.dark:text-gray-100]="mes.numero !== mesAtual && mes.temDiasLetivos"
                    [class.bg-gray-100]="!mes.temDiasLetivos"
                    [class.dark:bg-gray-900]="!mes.temDiasLetivos"
                    [class.text-gray-400]="!mes.temDiasLetivos"
                    [class.cursor-pointer]="mes.temDiasLetivos"
                    [disabled]="!mes.temDiasLetivos"
                  >
                    <div class="text-sm font-medium">{{ mes.nome }}</div>
                    <div *ngIf="!mes.temDiasLetivos" class="text-xs mt-1">sem dias</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Grade do Calendário (Angular Material — alinhamento consistente) -->
          <div id="calendario-grade" class="p-4">
            <app-calendario-frequencia
              [mesAtual]="mesAtual"
              [anoAtual]="anoAtual"
              [diaSelecionado]="diaSelecionado"
              [diasLetivosDoMes]="diasLetivosDoMes"
              [periodoDataInicial]="periodoAtual?.dataInicial ?? null"
              [periodoDataFinal]="periodoAtual?.dataFinal ?? null"
              (diaSelecionadoChange)="selecionarDiaCalendario($event)"
            ></app-calendario-frequencia>
          </div>
          
          <!-- Rodapé com ações -->
          <div id="calendario-rodape" class="px-4 py-3 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 space-y-2">
            <!-- Botão Hoje -->
            <button
              id="calendario-ir-para-hoje-btn"
              (click)="voltarParaHoje()"
              class="w-full px-4 py-2 bg-blue-600 dark:bg-blue-600 hover:bg-blue-700 dark:hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors flex items-center justify-center space-x-2"
            >
              <lucide-icon name="calendar-days" class="w-4 h-4"></lucide-icon>
              <span>Ir para Hoje</span>
            </button>
            
            <!-- Legenda -->
            <div id="calendario-legenda" class="flex items-center justify-center gap-4 pt-1 text-xs text-gray-600 dark:text-gray-300">
              <div class="flex items-center gap-1.5">
                <div class="w-3 h-3 rounded-full bg-blue-600 dark:bg-blue-500"></div>
                <span>Dia selecionado</span>
              </div>
              <div class="flex items-center gap-1.5">
                <div class="w-3 h-3 rounded-full bg-blue-100 dark:bg-blue-900 border border-blue-300 dark:border-blue-700"></div>
                <span>Hoje</span>
              </div>
              <div class="flex items-center gap-1.5">
                <div class="w-3 h-3 rounded-full border-2 border-gray-400 dark:border-gray-500 opacity-40"></div>
                <span>Não letivo</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Checkbox: Marque ao lado para registrar a frequência dos alunos (somente dia letivo) -->
      <div *ngIf="shouldShowCheckboxAulaRealizada()" id="aula-realizada-container" class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-2 mb-1">
        <label id="aula-realizada-label" class="flex items-center justify-between cursor-pointer" [class.opacity-50]="semContexto" [class.cursor-not-allowed]="semContexto">
          <span class="text-sm text-gray-700 dark:text-gray-200 flex-1">
            Marque ao lado para registrar a frequência dos alunos
          </span>
          <input
            id="aula-realizada-checkbox"
            type="checkbox"
            [(ngModel)]="aulaRealizada"
            (change)="onAulaRealizadaChange(aulaRealizada)"
            [disabled]="semContexto"
            class="w-5 h-5 text-green-600 border-gray-300 dark:border-gray-600 rounded focus:ring-green-500 ml-3 flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed"
          >
        </label>
      </div>

      <!-- Empty state para qualquer data selecionada não letiva -->
      <div *ngIf="shouldShowDataNaoLetivaEmptyState()"
           class="bg-white dark:bg-gray-800 rounded-lg p-8 text-center border border-gray-200 dark:border-gray-700 m-3">
        <lucide-icon name="calendar-x2" class="w-10 h-10 text-gray-400 dark:text-gray-500 mx-auto mb-3"></lucide-icon>
        <p class="text-gray-700 dark:text-gray-200 text-sm font-medium">
          A data selecionada não é letiva neste período.
        </p>
        <p class="text-gray-500 dark:text-gray-400 text-xs mt-1">
          Selecione manualmente uma data letiva no calendário.
        </p>
      </div>

      <!-- Legenda e Ordenação (apenas modo Dia; oculto sem dias letivos no mês ou data não letiva) -->
      <div id="legenda-ordenacao-container" *ngIf="tipoTelaFrequencia === 'dia' && !deveOcultarGradeFrequenciaPorCalendario()"
           class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-3 mb-1">
        <div class="flex items-center justify-between">
          <!-- Dropdown de Ordenação -->
          <div id="ordenacao-seletor" class="relative">
            <button
              id="ordenacao-dropdown-btn"
              (click)="toggleOrdenacaoDropdown()"
              [disabled]="semContexto || enturmacoes.length === 0"
              class="flex items-center space-x-2 px-3 py-2 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-300 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white dark:disabled:hover:bg-gray-700"
            >
              <lucide-icon 
                [name]="getIconeOrdenacaoAtual()" 
                class="w-4 h-4">
              </lucide-icon>
              <lucide-icon 
                [name]="ordenacaoDropdownAberto ? 'chevron-up' : 'chevron-down'" 
                class="w-3 h-3">
              </lucide-icon>
            </button>

            <!-- Dropdown Menu -->
            <div
              id="ordenacao-dropdown-lista"
              *ngIf="ordenacaoDropdownAberto"
              class="absolute left-0 mt-2 w-64 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-50"
            >
              <div class="py-1">
                <button
                  id="ordenacao-alfa-asc-btn"
                  (click)="selecionarOrdenacao('alfabetica', 'asc')"
                  [class]="tipoOrdenacao === 'alfabetica' && direcaoOrdenacao === 'asc' 
                    ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400' 
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                  class="w-full flex items-center space-x-3 px-4 py-2.5 transition-colors"
                >
                  <lucide-icon name="arrow-down-a-z" class="w-4 h-4"></lucide-icon>
                  <span class="text-sm">Ordem alfabética A-Z</span>
                </button>
                
                <button
                  id="ordenacao-alfa-desc-btn"
                  (click)="selecionarOrdenacao('alfabetica', 'desc')"
                  [class]="tipoOrdenacao === 'alfabetica' && direcaoOrdenacao === 'desc' 
                    ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400' 
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                  class="w-full flex items-center space-x-3 px-4 py-2.5 transition-colors"
                >
                  <lucide-icon name="arrow-down-z-a" class="w-4 h-4"></lucide-icon>
                  <span class="text-sm">Ordem alfabética Z-A</span>
                </button>
                
                <button
                  id="ordenacao-num-asc-btn"
                  (click)="selecionarOrdenacao('numeroChamada', 'asc')"
                  [class]="tipoOrdenacao === 'numeroChamada' && direcaoOrdenacao === 'asc' 
                    ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400' 
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                  class="w-full flex items-center space-x-3 px-4 py-2.5 transition-colors"
                >
                  <lucide-icon name="arrow-down-0-1" class="w-4 h-4"></lucide-icon>
                  <span class="text-sm">Nº da chamada crescente</span>
                </button>
                
                <button
                  id="ordenacao-num-desc-btn"
                  (click)="selecionarOrdenacao('numeroChamada', 'desc')"
                  [class]="tipoOrdenacao === 'numeroChamada' && direcaoOrdenacao === 'desc' 
                    ? 'bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400' 
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'"
                  class="w-full flex items-center space-x-3 px-4 py-2.5 transition-colors"
                >
                  <lucide-icon name="arrow-down-1-0" class="w-4 h-4"></lucide-icon>
                  <span class="text-sm">Nº da chamada decrescente</span>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Legendas (compactas) -->
          <div id="legenda-frequencia" class="flex items-center space-x-2">
            <div id="legenda-presenca" class="flex items-center space-x-1">
              <div class="w-6 h-6 bg-green-500 text-white rounded flex items-center justify-center font-bold text-[11px]">P</div>
              <span class="text-[11px] text-gray-600 dark:text-gray-300">Presença</span>
            </div>
            <div id="legenda-falta" class="flex items-center space-x-1">
              <div class="w-6 h-6 bg-red-500 text-white rounded flex items-center justify-center font-bold text-[11px]">F</div>
              <span class="text-[11px] text-gray-600 dark:text-gray-300">Falta</span>
            </div>
            <div id="legenda-dispensa" class="flex items-center space-x-1">
              <div class="w-6 h-6 bg-yellow-500 text-white rounded flex items-center justify-center font-bold text-[11px]">D</div>
              <span class="text-[11px] text-gray-600 dark:text-gray-300">Dispensa</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Decisão: Frequência por Dia ou por Aula -->
      <div id="frequencia-tipo-switch" [ngSwitch]="tipoTelaFrequencia">
        <!-- Frequência por Dia (implementação existente) -->
        <div id="frequencia-por-dia" *ngSwitchCase="'dia'">
          <!-- Modo dia: trocou de mês no calendário sem escolher um dia letivo -->
          <div
            *ngIf="shouldShowSelecioneDiaLetivoEmptyState()"
            id="frequencia-selecione-dia-letivo"
            role="status"
            aria-live="polite"
            class="flex flex-col items-center justify-center text-center px-4 py-10 mx-1 rounded-xl border border-dashed border-amber-200/90 dark:border-amber-800/70 bg-gradient-to-b from-amber-50/90 to-white dark:from-amber-950/30 dark:to-gray-900/40"
          >
            <div
              class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100/90 dark:bg-amber-900/40 ring-1 ring-inset ring-amber-200/90 dark:ring-amber-800/60"
              aria-hidden="true"
            >
              <lucide-icon name="calendar-days" class="h-8 w-8 text-amber-600 dark:text-amber-400" [strokeWidth]="1.5"></lucide-icon>
            </div>
            <h3 class="text-base font-semibold text-gray-900 dark:text-gray-100">
              Escolha um dia letivo
            </h3>
            <p class="mt-2 max-w-sm text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
              O mês foi alterado. Toque em um dia letivo (destacado) no calendário para carregar a lista de alunos, ou feche e volte ao mês anterior.
            </p>
          </div>

          <!-- Lista de Alunos (ordenados alfabeticamente); oculta em data não letiva -->
          <div id="alunos-lista-container" *ngIf="!shouldShowSelecioneDiaLetivoEmptyState() && !deveOcultarGradeFrequenciaPorCalendario()" class="space-y-1">
            <!-- Skeleton Loading Cards (Pulsando) -->
            <div id="alunos-loading-skeleton" *ngIf="carregandoListaAlunos" class="space-y-1">
              <div *ngFor="let i of [1,2,3,4,5,6]; trackBy: trackByIndex"
                   [attr.id]="'aluno-skeleton-' + i" 
                   class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-2 animate-pulse">
                <div class="flex items-center justify-between">
                  <!-- Número e Nome (placeholder) -->
                  <div class="flex items-center space-x-3 flex-1">
                    <div class="w-8 h-6 bg-gray-300 dark:bg-gray-600 rounded"></div>
                    <div class="h-5 bg-gray-300 dark:bg-gray-600 rounded w-2/3"></div>
                  </div>
                  
                  <!-- Botões (placeholder) -->
                  <div class="flex items-center space-x-3">
                    <div class="w-8 h-8 bg-gray-300 dark:bg-gray-600 rounded-lg"></div>
                    <div class="w-10 h-10 bg-gray-300 dark:bg-gray-600 rounded"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Lista Real de Alunos -->
            <div id="alunos-lista" *ngIf="!carregandoListaAlunos">
              <app-mobile-frequencia-aluno-card-dia
                *ngFor="let aluno of alunosOrdenados; let i = index; trackBy: trackByAlunoId"
                [aluno]="aluno"
                [numero]="i + 1"
                [aulaRealizada]="aulaRealizada"
                [alterando]="isAlterandoFrequencia(aluno.id)"
                [abonosJustificativasCount]="getAbonosJustificativasCount(aluno)"
                (togglePresenca)="togglePresenca($event)"
                (abrirAbonosJustificativas)="abrirAbonosJustificativas($event)">
              </app-mobile-frequencia-aluno-card-dia>
            </div>
            
            <!-- Mensagem quando não há alunos (mas não há erro de configuração e há contexto válido) -->
            <!-- carregandoDadosTurma / carregandoDadosIniciais: evita flash durante troca de turma
                 quando tipoTelaFrequencia ainda está em 'dia' (valor da turma anterior). -->
            <div
              id="alunos-vazio"
              *ngIf="diaSelecionado !== null && enturmacoes.length === 0 && !mensagem && !semContexto && !carregandoDadosTurma && !carregandoDadosIniciais"
              role="status"
              aria-live="polite"
              class="flex flex-col items-center justify-center text-center px-4 py-10 rounded-xl border border-dashed border-gray-200 dark:border-gray-600 bg-gradient-to-b from-gray-50/90 to-white dark:from-gray-800/90 dark:to-gray-900/40"
            >
              <div
                class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 dark:bg-blue-900/35 ring-1 ring-inset ring-blue-100/90 dark:ring-blue-800/60"
                aria-hidden="true"
              >
                <lucide-icon name="users" class="h-8 w-8 text-blue-500 dark:text-blue-400" [strokeWidth]="1.5"></lucide-icon>
              </div>
              <h3 class="text-base font-semibold text-gray-900 dark:text-gray-100">
                  Não há alunos enturmados
              </h3>
              <p class="mt-2 max-w-sm text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
                  Para mais informações entre em contato com a secretaria escolar.
              </p>
            </div>
          </div>
        </div>

        <!-- Frequência por Aula (nova implementação); oculto em data não letiva -->
        <div id="frequencia-por-aula" *ngSwitchCase="'aula'">
          <app-mobile-frequencia-aula
            *ngIf="!deveOcultarGradeFrequenciaPorCalendario()"
            id="frequencia-aula-component"
            [turmaId]="getTurmaId()"
            [periodoId]="getPeriodoId()"
            [turmaFrequenciaMeta]="turmaCompleta ?? null"
            [itemEducacionalIds]="getItemEducacionalIds()"
            [dataSelecionada]="getDataSelecionada()"
            [periodoFechado]="isPeriodoFechado()"
            [enturmacoesInput]="enturmacoesAula"
            [enturmacoesCarregadas]="enturmacoesAulaCarregadas"
            [aulasCabecalhoInput]="aulasCabecalhoAula"
            [frequenciasAulasInput]="frequenciasAulasData"
            [aulaRealizada]="aulaRealizada"
            [canOpenAbonoJustificativa]="canOpenAbonoJustificativa"
            (abonoSolicitado)="abrirAbonosJustificativasAula($event)"
          ></app-mobile-frequencia-aula>
        </div>

        <!-- Loading inicial (enquanto carrega configuração) -->
        <div id="frequencia-loading-inicial" *ngSwitchDefault class="flex items-center justify-center py-12">
          <div class="text-center">
            <div class="inline-block animate-spin rounded-full h-12 w-12 border-4 border-orange-500 border-t-transparent mb-4"></div>
            <p class="text-gray-600 dark:text-gray-400">Carregando configuração...</p>
          </div>
        </div>
      </div>

      </div><!-- Fim do conteúdo normal -->
</div>

<!-- Modal de Loading - Preparando dados da turma -->
<div id="modal-loading-turma" *ngIf="carregandoDadosTurma" 
     class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
  <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-8 m-4 max-w-sm w-full border border-orange-200 dark:border-orange-900">
    <!-- Spinner -->
    <div class="flex justify-center mb-6">
      <div class="relative w-16 h-16">
        <div class="absolute inset-0 border-4 border-orange-200 dark:border-orange-900 rounded-full"></div>
        <div class="absolute inset-0 border-4 border-transparent border-t-orange-500 dark:border-t-orange-400 rounded-full animate-spin"></div>
      </div>
    </div>
    
    <!-- Mensagem -->
    <p class="text-center text-gray-800 dark:text-gray-200 font-medium text-lg">
      Preparando dados da turma selecionada...
    </p>
  </div>
</div>

<!-- Modal de Abonos e Justificativas -->
<app-abono-justificativa-modal
  id="modal-abono-justificativa"
  *ngIf="alunoSelecionadoParaAbonos"
  [isOpen]="abonosModalAberto"
  [enturmacaoId]="getEnturmacaoId()"
  [alunoNome]="getAlunoNome()"
  [turmaNome]="getTurmaNome()"
  [tipoFrequencia]="getTipoFrequencia()"
  [periodoAvaliativoId]="getPeriodoId()"
  [periodoDescricao]="getPeriodoDescricao()"
  [itemEducacionalIds]="getItemEducacionalIds()"
  [isEjaModular]="getIsEjaModular()"
  (fechado)="fecharAbonosModal()"
  (salvo)="onAbonoJustificativaSalvo($event)"
></app-abono-justificativa-modal>
